/*! @pentacode/ui v0.1.0 */
import "../../icon-DGn-d_zv.js";
import { html as e, nothing as t } from "lit";
//#region src/elements/table/table-header-renderers.ts
function n(n = {}) {
	let { icon: r, direction: i = "down" } = n;
	return {
		headerClass: `vertical-header vertical-header-${i}`,
		headerRenderer: ({ column: n }) => {
			let a = r ? e`<ptc-ui-icon name=${r}></ptc-ui-icon>` : t, o = e`<span class="vertical-header-text">${n.headerName}</span>`;
			return e`<span class="vertical-header-label">
                ${i === "up" ? e`${o}${a}` : e`${a}${o}`}
            </span>`;
		}
	};
}
//#endregion
export { n as verticalHeader };

//# sourceMappingURL=table-header-renderers.js.map